function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15 0C23.2839 0 30 6.7161 30 15C30 23.2839 23.2836 30 15 30C6.7164 30 0 23.2857 0 15C0 6.7143 6.7152 0 15 0Z",
  fill: "#23A881"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.8482 10.7954V13.024L16.8494 13.0246C20.9838 13.2155 24.0918 14.0353 24.0918 15.0172C24.0918 15.9991 20.9838 16.8189 16.8494 17.0098V24.1491H13.1644V17.0104C9.02398 16.8189 5.9082 15.9985 5.9082 15.0157C5.9082 14.0329 9.02248 13.2125 13.1644 13.0222V10.7954H8.06798V7.39962H21.944V10.7954H16.8482ZM16.8494 16.4033V16.4051L16.85 16.4036C20.5008 16.2409 23.2272 15.6027 23.2272 14.8428C23.2272 14.0829 20.502 13.445 16.85 13.2823V15.7708C16.7451 15.7804 16.1738 15.8277 15.0374 15.8277C14.0913 15.8277 13.4059 15.7873 13.1662 15.7708V13.2823C9.50724 13.4447 6.77555 14.0811 6.77555 14.8437C6.77555 15.6063 9.50695 16.2436 13.1662 16.4057V16.4027C13.402 16.415 14.071 16.442 15.0219 16.442C16.2113 16.442 16.7454 16.4099 16.8494 16.4033Z",
  fill: "white"
});
function SvgTokenUsdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenUsdt);
export default __webpack_public_path__ + "static/media/token-usdt.00b5ec9c661aa3bc57b2481923152c8b.svg";
export { ForwardRef as ReactComponent };